function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31919",
  "data-name": "Path 31919",
  d: "M306.492,113.56a33.143,33.143,0,1,0,0,.005Z",
  transform: "translate(-240.18 -80.42)",
  fill: "none"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_9158",
  "data-name": "Rectangle 9158",
  width: 3.444,
  height: 8.883,
  fill: "none"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_19968",
  "data-name": "Group 19968",
  transform: "translate(-933.2 -1683.037)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_19952",
  "data-name": "Group 19952"
}, /*#__PURE__*/React.createElement("g", {
  id: "no-user-found",
  transform: "translate(933.2 1683.037)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31891",
  "data-name": "Path 31891",
  d: "M296.38,108.506A28.1,28.1,0,1,1,268.289,80.42a28.1,28.1,0,0,1,28.091,28.086Z",
  transform: "translate(-208.88 -45.957)",
  fill: "#fff",
  stroke: "#d9d9d9",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_19387",
  "data-name": "Group 19387",
  transform: "translate(31.176 34.801)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31912",
  "data-name": "Path 31912",
  d: "M265.039,97.582a.162.162,0,1,1-.053-.12.161.161,0,0,1,.053.12Z",
  transform: "translate(-225.061 -69.938)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31918",
  "data-name": "Path 31918",
  d: "M256.5,97.582a.146.146,0,0,0,.162.162.162.162,0,1,0,0-.323.146.146,0,0,0-.162.162Z",
  transform: "translate(-230.118 -69.938)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_19389",
  "data-name": "Group 19389"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18801",
  "data-name": "Group 18801",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18598",
  "data-name": "Group 18598",
  transform: "translate(91.153)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18578",
  "data-name": "Group 18578",
  opacity: 0.6
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18577",
  "data-name": "Group 18577"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18576",
  "data-name": "Group 18576",
  clipPath: "url(#clip-path-2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31272",
  "data-name": "Path 31272",
  d: "M1315.184,414.119c.3,2.451-.191,4.526-1.094,4.636s-1.877-1.787-2.176-4.238.191-4.526,1.093-4.636,1.877,1.787,2.176,4.238",
  transform: "translate(-1311.828 -409.877)",
  fill: "#fff"
}))))), /*#__PURE__*/React.createElement("line", {
  id: "Line_2207",
  "data-name": "Line 2207",
  x2: 14.073,
  transform: "translate(5.733 102.844)",
  fill: "none",
  stroke: "#cad4dd",
  strokeWidth: 2,
  strokeDasharray: 5,
  opacity: 0.58
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2341",
  "data-name": "Line 2341",
  x2: 14.073,
  transform: "translate(135.733 38.226)",
  fill: "none",
  stroke: "#cad4dd",
  strokeWidth: 2,
  strokeDasharray: 5,
  opacity: 0.58
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2208",
  "data-name": "Line 2208",
  x2: 26.582,
  transform: "translate(0 112.226)",
  fill: "none",
  stroke: "#cad4dd",
  strokeWidth: 2,
  strokeDasharray: 5,
  opacity: 0.58
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2342",
  "data-name": "Line 2342",
  x2: 26.582,
  transform: "translate(130 28.844)",
  fill: "none",
  stroke: "#cad4dd",
  strokeWidth: 2,
  strokeDasharray: 5,
  opacity: 0.58
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7518",
  "data-name": "Rectangle 7518",
  width: 2.085,
  height: 12.509,
  rx: 1.042,
  transform: "translate(128.623 106.23)",
  fill: "#d8dade"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7519",
  "data-name": "Rectangle 7519",
  width: 2.085,
  height: 12.509,
  rx: 1.042,
  transform: "translate(135.919 111.442) rotate(90)",
  fill: "#d8dade"
}), /*#__PURE__*/React.createElement("path", {
  id: "Union_161",
  "data-name": "Union 161",
  d: "M-2011.987-8521.57v-4.169h-4.17a1.043,1.043,0,0,1-1.043-1.043,1.043,1.043,0,0,1,1.043-1.043h4.17V-8532a1.043,1.043,0,0,1,1.043-1.043A1.043,1.043,0,0,1-2009.9-8532v4.17h4.169a1.043,1.043,0,0,1,1.043,1.043,1.043,1.043,0,0,1-1.043,1.043h-4.169v4.169a1.042,1.042,0,0,1-1.041,1.041A1.042,1.042,0,0,1-2011.987-8521.57Z",
  transform: "translate(2029.97 8603.979)",
  fill: "#d9d9d9",
  opacity: 0.62
}), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2885",
  "data-name": "Ellipse 2885",
  transform: "translate(39.599 21.166)",
  fill: "#fff",
  stroke: "#d8dade",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 4.691,
  cy: 4.691,
  r: 4.691,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.691,
  cy: 4.691,
  r: 3.691,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "mail-reply",
  d: "M11.839,10.785a23.68,23.68,0,0,1,7.667,2.423,17.727,17.727,0,0,1,5.522,4.41,24.964,24.964,0,0,1,3.456,5.522,30.4,30.4,0,0,1,2.026,6.316Q24.312,20.8,11.839,20.8v6.912L0,15.87,11.839,4.031Z",
  transform: "translate(44.436 46.111)",
  fill: "#f3994e"
})))), /*#__PURE__*/React.createElement("g", {
  id: "emoji-smile",
  transform: "translate(1023.2 1702.279)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_32070",
  "data-name": "Path 32070",
  d: "M12.4,23.25A10.85,10.85,0,1,0,1.55,12.4,10.85,10.85,0,0,0,12.4,23.25Zm0,1.55A12.4,12.4,0,1,0,0,12.4,12.4,12.4,0,0,0,12.4,24.8Z",
  fill: "#d8dade",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_32071",
  "data-name": "Path 32071",
  d: "M9.466,21.479a.775.775,0,0,1,1.059.284,5.427,5.427,0,0,0,9.4,0,.775.775,0,1,1,1.342.775,6.977,6.977,0,0,1-12.084,0,.775.775,0,0,1,.284-1.059Z",
  transform: "translate(-2.824 -6.65)",
  fill: "#d8dade",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_32072",
  "data-name": "Path 32072",
  d: "M14.35,13.575c0,1.283-.694,2.325-1.55,2.325s-1.55-1.042-1.55-2.325.694-2.325,1.55-2.325S14.35,12.292,14.35,13.575Zm6.2,0c0,1.283-.694,2.325-1.55,2.325s-1.55-1.042-1.55-2.325S18.144,11.25,19,11.25,20.55,12.292,20.55,13.575Z",
  transform: "translate(-3.5 -3.5)",
  fill: "#d8dade"
})), /*#__PURE__*/React.createElement("path", {
  id: "star",
  d: "M14.666,6.709a1.148,1.148,0,0,0-.911-.782l-3.283-.533L8.949,2.436a1.153,1.153,0,0,0-2.05,0L5.377,5.394l-3.283.533a1.153,1.153,0,0,0-.633,1.95L3.8,10.239,3.3,13.526a1.152,1.152,0,0,0,1.659,1.205l2.97-1.5,2.97,1.5a1.153,1.153,0,0,0,1.659-1.205l-.507-3.288,2.343-2.362a1.148,1.148,0,0,0,.278-1.168Zm-.921.53L11.08,9.926l.577,3.74a.246.246,0,0,1-.355.257l-3.378-1.7-3.378,1.7a.246.246,0,0,1-.355-.257l.577-3.74L2.1,7.239a.247.247,0,0,1,.135-.417l3.735-.607L7.705,2.851a.246.246,0,0,1,.438,0L9.874,6.215l3.735.607a.247.247,0,0,1,.135.417Z",
  transform: "translate(942.999 1715.667)",
  fill: "#d8dade"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_19967",
  "data-name": "Group 19967",
  transform: "translate(-3 -9.305)"
}, /*#__PURE__*/React.createElement("g", {
  id: "chat-dots-fill",
  transform: "translate(1009 1742.005)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_32074",
  "data-name": "Path 32074",
  d: "M54.074,25.907c0,13.066-12.1,23.657-27.037,23.657A30.62,30.62,0,0,1,19.1,48.529,49.33,49.33,0,0,1,4.975,52.7a.879.879,0,0,1-.922-1.224,36,36,0,0,0,2.6-10.025A21.968,21.968,0,0,1,0,25.907C0,12.841,12.1,2.25,27.037,2.25S54.074,12.841,54.074,25.907Zm-37.176,0a3.38,3.38,0,1,1-3.38-3.38A3.38,3.38,0,0,1,16.9,25.907Zm13.518,0a3.38,3.38,0,1,1-3.38-3.38A3.38,3.38,0,0,1,30.416,25.907Zm10.139,3.38a3.38,3.38,0,1,0-3.38-3.38A3.38,3.38,0,0,0,40.555,29.287Z",
  transform: "translate(0 -2.25)",
  fill: "#fff",
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  id: "chat-dots-fill-2",
  "data-name": "chat-dots-fill",
  transform: "translate(1012.418 1743.144)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_32074-2",
  "data-name": "Path 32074",
  d: "M54.074,25.907c0,13.066-12.1,23.657-27.037,23.657A30.62,30.62,0,0,1,19.1,48.529,49.33,49.33,0,0,1,4.975,52.7a.879.879,0,0,1-.922-1.224,36,36,0,0,0,2.6-10.025A21.968,21.968,0,0,1,0,25.907C0,12.841,12.1,2.25,27.037,2.25S54.074,12.841,54.074,25.907Zm-37.176,0a3.38,3.38,0,1,1-3.38-3.38A3.38,3.38,0,0,1,16.9,25.907Zm13.518,0a3.38,3.38,0,1,1-3.38-3.38A3.38,3.38,0,0,1,30.416,25.907Zm10.139,3.38a3.38,3.38,0,1,0-3.38-3.38A3.38,3.38,0,0,0,40.555,29.287Z",
  transform: "translate(0 -2.25)",
  fill: "#d9d9d9",
  fillRule: "evenodd"
}))));
function SvgNoRespondFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 156.582,
    height: 118.74,
    viewBox: "0 0 156.582 118.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRespondFound);
export default __webpack_public_path__ + "static/media/no-respond-found.75bdb901.svg";
export { ForwardRef as ReactComponent };